import React from 'react'
import styled from '@emotion/styled'
import { colors, radius, spacing } from '@mobi/component-library/Theme/Common'

const VenueIcon = () => (
  // this is a cleaned version of the one in the mock to remove the crud, refer https://jakearchibald.github.io/svgomg/
  // - also the starting position was manually adjusted to (4 1) from (0 0)
  <svg viewBox='4 1 24 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fill='#fff'
      d='M16.002 1.583c6.443 0 11.666 5.224 11.666 11.667v.291c-.01 1.83-.43 9.09-11.104 15.147a1.15 1.15 0 0 1-1.124 0C4.055 22.229 4.334 14.406 4.335 13.542c0-.01.002-.019.003-.027a11.885 11.885 0 0 1-.003-.265c0-6.443 5.224-11.667 11.667-11.667Z'
    />
    <path fill='#4E2A69' d='M16 22.583a9.333 9.333 0 1 0 0-18.666 9.333 9.333 0 0 0 0 18.666Z' />
    <path
      fill='#fff'
      d='m17.242 12.086-.215-.838c-.066-.259-.347-.46-.623-.46h-1.747l-1.312 5.433h1.163c.175 0 .35-.132.386-.294l.18-.755h1.422l.746-3.086Zm-1.883 1.931.378-1.558h.123l.368 1.559h-.869ZM20.732 13.227c.311-.232.5-.614.5-1.01 0-.908-.623-1.426-1.712-1.426h-1.655l-.72 2.99v1.878c0 .294.066.566.558.566h1.865c1.093 0 1.888-.71 1.888-1.694 0-.58-.268-1.062-.724-1.304Zm-2.235-1.229h.94c.263 0 .412.132.412.365 0 .268-.149.404-.447.404h-.9v-.768h-.005Zm.962 3.007h-.962v-1.11h.962c.381 0 .61.21.61.557 0 .132-.044.553-.61.553ZM13.033 16.22l.233-.96v-3.165h.763l.316-1.308h-3.897c-.198 0-.281.08-.281.263v.782c0 .166.1.259.28.259h1.3v3.858c0 .175.11.267.312.267h.974v.005Z'
    />
  </svg>
)

interface Props {
  onClick: () => void
}

export const VenueIconButton = React.forwardRef<HTMLButtonElement, Props>(({ onClick }, ref) => (
  <StyledButton onClick={onClick} ref={ref}>
    <IconStyled>
      <VenueIcon />
    </IconStyled>
  </StyledButton>
))

VenueIconButton.displayName = 'VenueIconButton'

const IconStyled = styled.div({
  width: '24px',
  height: '28px',
})

const StyledButton = styled.button({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 0,
  flex: '1 0 0',

  padding: spacing.smx1,
  width: '4rem',

  borderRadius: radius.lg,
  background: colors.warning[700],
  border: 'none',
  cursor: 'pointer',
})
